export const CHECKOUT_URL = 'PEGAR_AQUÍ_LINK_DE_IMPULTIENDA';

export const SEO_TITLE = 'Profes de Telas Resuelto™ | Tu año completo de clases';
export const SEO_DESCRIPTION =
  'Sistema digital para profes de telas con 7 tomos, más de 60 clases, 5 bonos y 12 meses de planificación.';

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/rFW1ZxYFrKNokKZS6cnYip/mockup_sin_fondo.png';
